import React, { useEffect, useContext, useState } from 'react'
import { Helmet } from 'react-helmet';
import { useNavigate, useLocation } from 'react-router-dom';
import { isTablet, isMobileOnly, isDesktop } from 'react-device-detect';
import {
  Box,
  Container,
  Hidden,
  Button,
} from '@mui/material';

import Moment from 'moment'
Moment.locale('fr')

import cropRotateIcon from "../images/cropRotateIcon.svg"

import UserContext from "../contexts/UserContext"
import LanguageContext from "../contexts/LanguageContext"
import { useTexte } from "../contexts/FormeAdresseContext"

import { GLB_URL_APIS } from "../utils/APIS"

import PlanCours from "../components/ui/Formation/PlanCours"
import MyMiniModal from "../components/ui/MyMiniModal"

import { fondDeLEcran, FOND_BANDE_BASSE } from "../components/ui/Formats/FormatsHelpers"
import FormatTitre from "../components/ui/Formats/FormatTitre"
import FormatVideo from "../components/ui/Formats/FormatVideo"
import FormatTexte from "../components/ui/Formats/FormatTexte"
import FormatQuestionnaireV2 from "../components/ui/Formats/FormatQuestionnaireV2"
import FormatQuizz from "../components/ui/Formats/FormatQuizz"
import FormatDiag from "../components/ui/Formats/FormatDiag"
import FormatFinDeModule from "../components/ui/Formats/FormatFinDeModule"
import FormatInputTexte from "../components/ui/Formats/FormatInputTexte"
import FinDeFormation from "../components/ui/Formats/FinDeFormation"
import FormatFeedback from "../components/ui/Formats/FormatFeedback"

import IcebreakerQuestions from "../components/ui/Formats/IcebreakerQuestions"

/* L'ancien « Questionnaire » n'a pas de `responses` en base : c'etait un
   curseur fixe a quatre crans, 1 a 4, dont la legende vivait dans
   `exerciceTitle` sous la forme « [1 : pas du tout - 4 : tout a fait] ». On
   fabrique les quatre paliers a partir de cette legende quand elle existe,
   sinon 1, 2, 3, 4. Sans points : ce format n'a jamais ete note. */
const adapterQuestionnaire = (format) => {
  if (!format || (Array.isArray(format.responses) && format.responses.length > 0)) return format
  let labels = ["1", "2", "3", "4"]
  const m = String(format.exerciceTitle || "").match(/\[\s*1\s*:\s*(.+?)\s*-\s*4\s*:\s*(.+?)\s*\]/i)
  if (m) labels = [m[1].trim(), "2", "3", m[2].trim()]
  return { ...format, responses: labels.map((label) => ({ label, points: 0 })) }
}

export const FormatSwitch = (props) => {

  //console.log(props)

  if (props?.format) {
    switch (props?.format?.type) {
      case 'Titre':
        return <FormatTitre {...props} />
      case 'Video':
        return <FormatVideo {...props} />
      case 'Texte':
        return <FormatTexte {...props} />
      case 'QuestionnaireV2':
        return <FormatQuestionnaireV2 {...props} />
      case 'Quizz':
        return <FormatQuizz {...props} />
      case 'Diagnostic':
        return <FormatDiag {...props} />
      /* 07/10/2026 : format « Fin de module » (fiche Notion de Nawal, partie
         B). A ne pas confondre avec l'ecran terminal `FinDeFormation`, plus bas. */
      case 'FinDeModule':
        return <FormatFinDeModule {...props} />
      case 'InputTexte':
        return <FormatInputTexte {...props} />
      /* ⛔ DEUX FORMATS DE L'ANCIEN LECTEUR, retrouves le 07/09/2026.
         Le lecteur a ete reconstruit a neuf en fevrier 2026 (commit 68be04a),
         et « Questionnaire » comme « Feedback » n'ont jamais ete reecrits :
         ils tombaient dans le `default` ci-dessous, un fragment vide. Un
         ECRAN BLANC, sans bouton, donc un parcours bloque. Onze modules
         d'IKOULA et deux modules importes d'AWS en contiennent.
         « Questionnaire » est un curseur d'accord a quatre paliers : un cas
         particulier de QuestionnaireV2, auquel on fournit les quatre paliers
         qu'il n'a pas en base (adapterQuestionnaire).
         « Feedback » est un compte de bonnes reponses : FormatFeedback. */
      case 'Questionnaire':
        return <FormatQuestionnaireV2 {...props} format={adapterQuestionnaire(props?.format)} />
      case 'Feedback':
        return <FormatFeedback {...props} />
      default:
        return (<></>)
    }
  } else {
    if (props?.actFormation?.isDone && props?.actIndex?.chapitre === "max") {
      return <FinDeFormation {...props} />
    } else if (props?.isEditor && props?.actIndex?.chapitre === "max") {
      return <FinDeFormation {...props} />
    } else {
      return (<></>)
    }
  }
}


const Formation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { actLanguage, languageValues } = useContext(LanguageContext)
  /* Tutoiement / vouvoiement selon la cible du module (07/10/2026,
     contexts/FormeAdresseContext.js). */
  const t = useTexte()
  const {
    currentUser,
    actPlan,
    actFormation,
    actIndex,
    lastDoneIndex,
  } = useContext(UserContext)

  const [haveToViewIcebreakerQuestions, setHaveToViewIcebreakerQuestions] = useState(null)

  useEffect(() => {
    if (actFormation && currentUser) {
      if (location?.pathname === "/icebreaker" && actFormation?.userResult === null && currentUser?.icebreakerQuestions !== null) {
        if (currentUser?.icebreakerQuestions?.annees === true || currentUser?.icebreakerQuestions?.secteurs === true || currentUser?.icebreakerQuestions?.diplome === true) {
          setHaveToViewIcebreakerQuestions(true)
        } else {
          setHaveToViewIcebreakerQuestions(false)
        }
      } else {
        setHaveToViewIcebreakerQuestions(false)
      }
    }
  }, [actFormation, currentUser, location])

  useEffect(() => {
    if (actFormation && !actFormation?.isOpen) {
      navigate('/dashboard')
    }
  }, [actFormation])

  /* ORIENTATION MODAL */
  const [previousOrientation, setPreviousOrientation] = useState(null)
  const [modalMustPortrait, setModalMustPortrait] = useState(false)
  const [modalMustLandscape, setModalMustLandscape] = useState(false)
  useEffect(() => {
    const handleResize = () => {
      let orientation = null;
      if (window.innerWidth >= window.innerHeight) {
        orientation = "landscape"
      } else {
        orientation = "portrait"
      }
      if (previousOrientation !== orientation) {
        setPreviousOrientation(orientation)
        let viewModalMustPortrait = false
        let viewModalMustLandscape = false
        if (isMobileOnly && orientation === "landscape") {
          viewModalMustPortrait = true
        } else if (isTablet && orientation === "portrait") {
          viewModalMustLandscape = true
        } else if (isDesktop && orientation === "portrait") {
          viewModalMustLandscape = true
        }
        setModalMustPortrait(viewModalMustPortrait)
        setModalMustLandscape(viewModalMustLandscape)
      }
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [previousOrientation])
  /* END ORIENTATION MODAL */


  /* PLAN DE COURS */
  const [viewPlanCours, setViewPlanCours] = useState(false)
  /* END PLAN DE COURS */

  /* ⛔ LE FOND DEPEND DU TYPE D'ECRAN, ET IL SE POSE ICI.
     Grammaire relevee sur les nodes Figma : les ecrans de CONTENU ont une page
     BLANCHE, tandis que Diagnostic, Plan de formation et Fin de module ont une
     page TEINTEE.
     ⚠️ Il se pose sur le conteneur de PAGE, jamais sur la racine du format, et
     la raison a change au lot H sans que la regle change. Au lot G, c'etait pour
     ne pas masquer le decor rendu en dessous ; le decor a depuis ete retire,
     faute d'exister dans les planches. La regle tient toujours, pour une raison
     plus simple : sept endroits rendent un format, et un fond pose sur le format
     devrait etre repose sept fois. */
  const formatCourant = actFormation?.chapitre[actIndex?.chapitre]?.partie[actIndex?.partie]?.sequence[actIndex?.sequence]
  /* ⚠️ La liste des types a fond blanc N'EST PAS ICI. Elle etait recopiee dans
     ce fichier, et cinq autres endroits rendent un format sans passer par cette
     page : ils sont restes teintes pendant que l'apprenant voyait blanc. La
     question se pose donc a `fondDeLEcran`, dans `FormatsHelpers`, a cote du
     tableau de mesures. L'icebreaker reste teinte : ce n'est pas un format. */
  const fondDePage = haveToViewIcebreakerQuestions === false
    ? fondDeLEcran(formatCourant)
    : FOND_BANDE_BASSE

  return (
    <>
      <Helmet>
        <title>{languageValues?.formation?.pageTitle[actLanguage] || ''} | TheLab</title>
      </Helmet>
      {viewPlanCours &&
        <PlanCours
          actFormation={actFormation}
          lastDoneIndex={lastDoneIndex}
          setViewPlanCours={setViewPlanCours}
          viewPlanCours={viewPlanCours}
          actPlan={actPlan}
        />
      }
      <Box
        sx={{
          backgroundColor: fondDePage,
          minHeight: '100%',
          py: 0,
          display:"flex",
          flexDirection:"column",
        }}
      >
      {/* ⛔ LOT H — LE DECOR DE MARQUE EST RETIRE DES PAGES DE COURS.
          Regle appliquee : ce qui n'apparait pas dans les planches actuelles de
          Valentin ne se maintient pas parce que le code le portait avant.
          Constat : les cinq planches Desktop lues au node — quiz 3:282231,
          quiz + image 4:559, questionnaire 3:241965, saisie 3:40519,
          Vrai/Faux 6:282 — donnent toutes une page `bg-white` SANS filigrane,
          sans degrade et sans grain.
          Contre-indice examine, et ecarte pour une raison de date : le
          09/09/2026, Hicham avait releve « on n'a pas les filigranes arriere »
          sur la vue admin. Cette remarque est ANTERIEURE au fichier Figma
          « Claude » du 17/09, qui fait desormais foi. Seule une decision
          posterieure au design actuel justifierait de le garder.
          `FondDeCours.js` n'est pas supprime : le retour arriere tient en une
          ligne si Valentin tranche dans l'autre sens. */}
        <Box
          sx={{
            flex:1,
            padding:0,
            backgroundColor:"transparent",
            zIndex:3,
          }}
        >
          {haveToViewIcebreakerQuestions === true &&
            <IcebreakerQuestions
              actFormation={actFormation}
            />
          }

          {haveToViewIcebreakerQuestions === false &&
            <FormatSwitch
              actFormation={actFormation}
              format={formatCourant}
              actIndex={actIndex}
              setViewPlanCours={setViewPlanCours}
              viewPlanCours={viewPlanCours}
              actPlan={actPlan}
            />
          }


        </Box>
      </Box>

      {/* MODAL MUST PORTRAIT */ }
      <MyMiniModal
        isOpen={modalMustPortrait}
        onClose={() => { setModalMustPortrait(false) }}
        title={languageValues?.modalMustPortrait?.title[actLanguage]}
        subTitle={t(languageValues?.modalMustPortrait?.text)}
        topIcon={cropRotateIcon}
      >
        <Box sx={{
          display:"flex",
          justifyContent:"center",
        }}>
          <Button
            color="primary"
            size="large"
            type="submit"
            variant="contained"
            onClick={() => { setModalMustPortrait(false) }}
          >
            {languageValues?.close[actLanguage]}
          </Button>
        </Box>
      </MyMiniModal>
      {/* END MODAL MUST PORTRAIT */ }

      {/* MODAL MUST LANDSCAPE */ }
      <MyMiniModal
        isOpen={modalMustLandscape}
        onClose={() => { setModalMustLandscape(false) }}
        title={languageValues?.modalMustLandscape?.title[actLanguage]}
        subTitle={t(languageValues?.modalMustLandscape?.text)}
        topIcon={cropRotateIcon}
      >
        <Box sx={{
          display:"flex",
          justifyContent:"center",
        }}>
          <Button
            color="primary"
            size="large"
            type="submit"
            variant="contained"
            onClick={() => { setModalMustLandscape(false) }}
          >
            {languageValues?.close[actLanguage]}
          </Button>
        </Box>
      </MyMiniModal>
      {/* END MODAL MUST LANDSCAPE */ }
    </>
  )
};

export default Formation;
